<template>
    <div class="card border-light borda-redonda sombra">
        <div class="card-body">
            <h6 class="card-title text-center">
                Compartilhe as fotos do atendimento
            </h6>
            <div class="card-text">
                <div class="col-12 mb-3 lh-18">
                    <small class="text-justify">
                        Para segurança do atendimento e do veículo nos envie as fotos de antes e depois da chegada do
                        prestador.
                    </small>
                </div>
                <div class="col-12 text-end">
                    <input type="file" ref="arquivosRef" hidden multiple accept="image/*;capture=camera"
                        @change="adicionarArquivo()">
                    <button type="button" class="btn btn-warning text-white" @click="escolherAnexo()"
                        :disabled="loading">
                        {{ loading ? `Aguarde ...` : `Enviar` }} 
                        <span class="material-symbols-outlined" style="vertical-align: bottom;">photo_camera</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { useAtendimentoStore } from '@/stores/atendimento';
import { toast, alert } from '@/helper/alerts';

const storeAtendimento = useAtendimentoStore();
const loading = ref(false);
const arquivosRef = ref(null);

async function adicionarArquivo() {
    const files = arquivosRef.value.files;
    if (files.length == 0) {
        return;
    }

    try {
        loading.value = true;
        let formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            let file = files[i];
            formData.append('files[' + i + ']', file);
        }

        const response = await storeAtendimento.enviarAnexos(formData);
        toast("success", response.message);
    } catch (error) {
        alert("error", "", error.message);
    } finally {
        loading.value = false;
    }
}

function escolherAnexo() {
    arquivosRef.value.value = "";
    arquivosRef.value.click();
}
</script>
